import React from 'react'
import {Button, Checkbox, Col, Row, Steps, Table} from 'antd'
import ImportExcelSheets from "../ImportExcelSheets";

class ImportExcelColumnsSelect extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            values: [],
            rawData: [],
            current: 0,
            fileName: this.props.fileName ?? 'Sheets',
            tableColumns: [],
            tableData: []
        }
    }

    componentDidMount() {
        const {columns} = this.props
        const defaultValues = []
        columns?.forEach((column) => {
            defaultValues.push(column.dataIndex)
        })
        this.setState({
            values: defaultValues,
        })
    }

    render() {

        const next = () => {
            this.setState({current: this.state.current + 1});
        };
        const prev = () => {
            this.setState({current: this.state.current - 1});
        };

        const onChange = (checkedValues) => {
            this.setState({
                values: checkedValues
            })
        };
        const {columns, allColumns} = this.props

        const getCheckBoxItems = () => {
            const layout = []
            {
                allColumns?.forEach((column) => {
                    layout.push(
                        <Col span={8}>
                            <Checkbox value={column.dataIndex}>{column.title}</Checkbox>
                        </Col>
                    )
                })
            }
            return layout
        }


        const contentLayout1 = () => {
            return (
                <>
                    <Row style={{marginTop: '6px'}}>
                        <p>Select fields to import</p>
                    </Row>
                    <Checkbox.Group onChange={onChange} value={this.state.values} style={{
                        width: '100%',
                    }}>
                        <Row>
                            {getCheckBoxItems()}
                        </Row>
                    </Checkbox.Group>
                </>
            )
        }

        const contentLayout2 = () => {
            const selectColumns = allColumns.filter((column)=>(this.state.values.includes(column.dataIndex)))

            return (
                <>
                    <ImportExcelSheets columns={selectColumns} fileName={this.state.fileName + "_template"}
                                       onDataLoaded={(columns, rows) => {
                                            const data = rows.map((item, idx) => {
                                                const obj = {}
                                                for (let i = 0; i < item.length; i++) {
                                                    if (item[i]) obj[columns[i].dataIndex] = String(item[i]).trim()
                                                }
                                                return obj
                                            })

                                           this.setState({
                                               tableColumns: columns,
                                               rawData: rows,
                                               tableData: data,
                                           })
                                       }}/>
                </>
            )
        }

        const contentLayout3 = () => {
            return (
                <Row>
                    <Table
                        scroll={{x: 1300}}
                        pagination={{
                            pageSize: 10
                        }}
                        columns={this.state.tableColumns}
                        dataSource={this.state.tableData}
                    />

                </Row>
            )
        }

        const steps = [
            {
                title: 'Select fields to import',
                content: contentLayout1(),
            },
            {
                title: 'Upload the excel template',
                content: contentLayout2(),
            },
            {
                title: 'Confirm update',
                content: contentLayout3(),
            },
        ];

        const items = steps.map((item) => ({
            key: item.title,
            title: item.title,
        }));

        return (
            <>
                <Steps current={this.state.current} items={items} direction="vertical"/>
                <Row>{steps[this.state.current].content}</Row>
                <Row justify="space-between"
                     style={{
                         marginTop: 36,
                     }}
                >
                    {this.state.current > 0 && (
                        <Button
                            style={{
                                margin: '0 8px',
                                float: "left",
                                marginLeft: 0
                            }}
                            onClick={() => prev()}
                        >
                            Previous
                        </Button>
                    )}
                    {this.state.current < steps.length - 1 && (
                        <Button type="primary" style={{float: 'right', marginLeft: 'auto'}} onClick={() => next()}>
                            Next
                        </Button>
                    )}
                    {this.state.current === steps.length - 1 && (
                        <Button type="primary" onClick={()=>{
                            if(this.props.onImportConfirm)
                                this.props.onImportConfirm(this.state.tableColumns, this.state.rawData)
                        }}>
                            Confirm
                        </Button>
                    )}
                </Row>
            </>
        )
    }
}

export default ImportExcelColumnsSelect
